<template>
  <div
    :class="{ 'drag-over': isDragging, 'dropzone-container': !hideContainer }"
    @dragover="onDragOver"
    @dragleave="onDragLeave"
    @drop="onDrop"
    @click="onClick"
  >
    <input
      type="file"
      name="file"
      id="fileInput"
      class="hidden-input"
      @change="onChange"
      ref="file"
      :accept="accept"
    />
    <slot></slot>
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import AzureStorage from '../../lib/AzureBlobStorage'

export default {
  name: 'Upload',
  props: {
    multiple: { type: Boolean, default: false },
    container: { type: String, required: true },
    accept: { type: String, default: '' },
    hideContainer: { type: Boolean, default: false },
    addTimestamp: { type: Boolean, default: false },
  },
  data() {
    return {
      isDragging: false,
    }
  },
  methods: {
    async onChange() {
      const files = Array.from(this.$refs.file.files)
      files.map((file) => {
        const timestamp = new Date().getTime()
        const _file = this.addTimestamp ? new File([file], `${timestamp}_${file.name}`) : file
        this.$emit('add', {
          azureFile: AzureStorage.createUpload(this.container, _file),
          file: _file,
        })
      })
    },
    onDragOver(evt) {
      evt.preventDefault()
      this.isDragging = true
    },
    onDragLeave() {
      this.isDragging = false
    },
    onDrop(evt) {
      evt.preventDefault()
      this.$refs.file.files = evt.dataTransfer.files
      this.onChange()
      this.isDragging = false
    },
    onClick() {
      this.$refs.file.click()
    },
    created() {
      if (this.multiple) this.$refs.file.setAttribute('multiple', '')
    },
  },
}
</script>

<style lang="less" scoped>
.dropzone-container {
  border: 2px solid #ececec;
  width: 100%;
  height: auto;
  &.drag-over {
    border-style: dashed;
    border-color: #ccc;
  }
  &:hover {
    border-color: #ccc;
    cursor: pointer;
  }
}
.hidden-input {
  opacity: 0;
  overflow: hidden;
  position: absolute;
  width: 1px;
  height: 1px;
}
</style>
